export default __webpack_public_path__ + "static/media/profile-photo.77c3a497.jpg";